import insightsApi from "@api/insights" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            targetingSets: false,
        },
        errors: {
            targetingSets: null,
        },
        targetingSets: [],
        clicks: [],
    },
    getters: {
        targetingSets: state => state.targetingSets,
        clicks: state => state.clicks,
        insightsLoadingState: state => name => state.loading[name],
        insightsErrorState: state => name => state.errors[name],
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        targetingSets(state, targetingSets) {
            const newTargetingSets = targetingSets.map(targetingSet => {
                targetingSet.bid_price = `$${(targetingSet.bid_price / 100).toFixed(2)}`
                return targetingSet
            })
            Vue.set(state, 'targetingSets', newTargetingSets)
        },
        clicks(state, clicks) {
            Vue.set(state, 'clicks', clicks)
        },
        clickReport(state, clickReport) {
            Vue.set(state, 'clickReport', clickReport)
        },
    },
    actions: {
        getTargetingSets({ commit }, payload) {
            commit('setLoadingState', { name: 'targetingSets', value: true })
            return insightsApi
                .getTargetingSets(payload.countryUuid, payload.categoryUuid)
                .then(response => {
                    const { data } = response.data
                    commit('targetingSets', data)
                })
                .catch(() => {
                    commit('setError', { name: 'targetingSets', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'targetingSets', value: false })
                })
        },
        initializeTargetingSets({ dispatch }, payload) {
            dispatch('getTargetingSets', payload)
        },
        getClicks({ commit }, params = {}) {
            commit('setLoadingState', { name: 'clicks', value: true })

            // Passes the params to the api's getClicks function
            return insightsApi.getClicks(params)
                .then(response => {
                    const { data } = response
                    commit('clicks', data)
                })
                .catch(() => {
                    commit('setError', { name: 'clicks', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'clicks', value: false })
                })
        },
    },
}
